export default __webpack_public_path__ + "static/media/complete_checkbox.ab793d59.svg";